import { render, staticRenderFns } from "./procurement_project_lot.vue?vue&type=template&id=645055f0&scoped=true&"
import script from "./procurement_project_lot.vue?vue&type=script&lang=js&"
export * from "./procurement_project_lot.vue?vue&type=script&lang=js&"
import style0 from "./procurement_project_lot.vue?vue&type=style&index=0&id=645055f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645055f0",
  null
  
)

export default component.exports